import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations
const translations = {
  it: {
    // Common
    common: {
      home: 'Home',
      search: 'Cerca',
      login: 'Accedi',
      logout: 'Esci',
      register: 'Registrati',
      save: 'Salva',
      cancel: 'Annulla',
      confirm: 'Conferma',
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      email: 'Email',
      password: 'Password',
      name: 'Nome',
      surname: 'Cognome',
      phone: 'Telefono',
      send: 'Invia',
      back: 'Indietro',
      next: 'Avanti',
      close: 'Chiudi',
      or: 'oppure',
      readMore: 'Leggi di più',
      viewAll: 'Vedi tutti',
      learnMore: 'Scopri di più'
    },
    // Header
    header: {
      searchObituaries: 'Cerca',
      funeralServices: 'Servizi Funebri',
      flowers: 'Fiori',
      resources: 'Risorse / Guide',
      aboutUs: 'Chi siamo',
      contact: 'Contattaci',
      reservedArea: 'Area Riservata',
      dashboard: 'Dashboard',
      welcome: 'Ciao'
    },
    // Homepage
    homepage: {
      heroTitle: 'Cerca una persona cara',
      heroSubtitle: 'Trova necrologi e commemora i tuoi cari per Nome, Parrocchia o Città',
      searchPlaceholder: 'Nome del defunto',
      cityPlaceholder: 'Città o Parrocchia',
      searchButton: 'Cerca',
      todayRemembrance: 'Ricorrenze di Oggi',
      todayRememberanceDesc: 'Unisciti alla comunità nel ricordo',
      todayThoughts: 'pensieri condivisi',
      sendThought: 'Invia un pensiero',
      recentObituaries: 'Necrologi Recenti',
      viewAllObituaries: 'Vedi tutti i necrologi',
      partnerAgencies: 'Agenzie Partner',
      becomePartner: 'Diventa Partner',
      moreInfo: 'Maggiori Informazioni',
      servicesTitle: 'I Nostri Servizi',
      servicesDesc: 'Offriamo servizi completi per commemorare i vostri cari'
    },
    // About Us Page
    aboutUs: {
      title: 'Chi Siamo',
      subtitle: 'Dedicati alla memoria e al ricordo',
      mission: 'La Nostra Missione',
      missionText: 'Resta in Pace nasce con l\'obiettivo di creare un luogo digitale dove la memoria dei nostri cari possa essere preservata e condivisa con dignità e rispetto.',
      vision: 'La Nostra Visione',
      visionText: 'Crediamo che ogni vita meriti di essere ricordata. Il nostro portale offre uno spazio sicuro e rispettoso dove famiglie e amici possono commemorare i propri cari.',
      values: 'I Nostri Valori',
      valueRespect: 'Rispetto',
      valueRespectDesc: 'Trattiamo ogni memoria con la massima dignità',
      valueProfessionalism: 'Professionalità',
      valueProfessionalismDesc: 'Servizio di alta qualità per ogni famiglia',
      valueDiscretion: 'Discrezione',
      valueDiscretionDesc: 'Privacy e riservatezza sempre garantite',
      team: 'Il Nostro Team',
      teamDesc: 'Un team dedicato al vostro servizio',
      contactUs: 'Contattaci',
      contactDesc: 'Siamo qui per aiutarti'
    },
    // Contact Page
    contact: {
      title: 'Contattaci',
      subtitle: 'Siamo qui per aiutarti',
      formTitle: 'Inviaci un messaggio',
      nameLabel: 'Il tuo nome',
      emailLabel: 'La tua email',
      subjectLabel: 'Oggetto',
      messageLabel: 'Il tuo messaggio',
      sendButton: 'Invia Messaggio',
      successMessage: 'Messaggio inviato con successo!',
      address: 'Indirizzo',
      phoneLabel: 'Telefono',
      emailContact: 'Email',
      workingHours: 'Orari di apertura',
      workingHoursValue: 'Lun - Ven: 9:00 - 18:00'
    },
    // Services Page
    services: {
      title: 'Servizi Funebri',
      subtitle: 'Servizi completi per il commiato',
      obituaryService: 'Pubblicazione Necrologi',
      obituaryServiceDesc: 'Pubblica necrologi online con foto, messaggi e dediche',
      flowersService: 'Invio Fiori',
      flowersServiceDesc: 'Invia composizioni floreali per esprimere vicinanza',
      candleService: 'Candele Virtuali',
      candleServiceDesc: 'Accendi una candela virtuale in memoria',
      memorialService: 'Pagine Commemorative',
      memorialServiceDesc: 'Crea pagine dedicate alla memoria dei tuoi cari',
      reminderService: 'Promemoria Anniversari',
      reminderServiceDesc: 'Ricevi notifiche per gli anniversari importanti',
      donationService: 'Donazioni',
      donationServiceDesc: 'Effettua donazioni in memoria del defunto'
    },
    // Itineraries
    itineraries: {
      title: 'Itinerari della Memoria',
      subtitle: 'Scopri i luoghi del ricordo in Italia',
      exploreMap: 'Esplora la Mappa',
      featuredItineraries: 'Itinerari in Evidenza',
      allItineraries: 'Tutti gli Itinerari',
      readArticle: 'Leggi l\'articolo',
      author: 'Autore',
      publishedOn: 'Pubblicato il'
    },
    // Login
    login: {
      privateLogin: 'Accesso Privati',
      agencyLogin: 'Accesso Agenzie',
      bloggerLogin: 'Accesso Blogger',
      privateLoginDesc: 'Accedi per gestire i tuoi ricordi e commemorazioni',
      agencyLoginDesc: 'Area dedicata alle agenzie funebri partner',
      bloggerLoginDesc: 'Area dedicata ai blogger per gestire i contenuti',
      loginTitle: 'Bentornato',
      registerTitle: 'Crea il tuo account',
      forgotPassword: 'Password dimenticata?',
      noAccount: 'Non hai un account?',
      hasAccount: 'Hai già un account?',
      rememberMe: 'Ricordami',
      loginButton: 'Accedi',
      registerButton: 'Registrati',
      orContinueWith: 'oppure continua con',
      termsAgree: 'Accetto i Termini e Condizioni',
      termsTitle: 'Termini e Condizioni',
      agencyName: 'Nome Agenzia',
      agencyCity: 'Città Agenzia',
      confirmPassword: 'Conferma Password',
      passwordMismatch: 'Le password non coincidono',
      invalidEmail: 'Email non valida',
      weakPassword: 'La password deve avere almeno 6 caratteri',
      loginError: 'Email o password non corretti',
      registerSuccess: 'Registrazione completata con successo',
      selectUserType: 'Tipo di account'
    },
    // Password Reset
    passwordReset: {
      title: 'Recupera Password',
      subtitle: 'Inserisci la tua email per ricevere il link di reset',
      sendLink: 'Invia Link di Reset',
      linkSent: 'Link inviato! Controlla la tua email',
      newPassword: 'Nuova Password',
      confirmNewPassword: 'Conferma Nuova Password',
      resetPassword: 'Reimposta Password',
      passwordChanged: 'Password modificata con successo',
      backToLogin: 'Torna al login',
      invalidToken: 'Link non valido o scaduto',
      tokenExpired: 'Il link è scaduto. Richiedine uno nuovo.'
    },
    // Footer
    footer: {
      description: 'Il portale italiano dedicato alla memoria, ai necrologi e alla cultura del commiato. Professionalità e discrezione al vostro servizio.',
      services: 'Servizi',
      resources: 'Risorse',
      contacts: 'Contatti',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      termsConditions: 'Termini e Condizioni',
      allRightsReserved: 'Tutti i diritti riservati',
      searchObituary: 'Cerca Necrologio',
      flowersAndThoughts: 'Fiori e Pensieri',
      funeralOrganization: 'Organizzazione Funerali',
      cemeteryServices: 'Servizi Cimiteriali',
      blogAndSupport: 'Blog & Supporto',
      faq: 'Domande Frequenti',
      practicalGuide: 'Guida Pratica',
      workWithUs: 'Lavora con Noi',
      administration: 'Amministrazione'
    },
    // Obituary
    obituary: {
      search: 'Cerca Necrologi',
      searchPlaceholder: 'Nome del defunto',
      cityPlaceholder: 'Città o Parrocchia',
      found: 'Trovati',
      obituaries: 'necrologi',
      viewObituary: 'Visualizza necrologio',
      sendFlowers: 'Invia Fiori',
      sendCondolence: 'Condoglio',
      share: 'Condividi',
      remindMe: 'Ricordami',
      lightCandle: 'Accendi una Candela',
      donate: 'Dona alla famiglia',
      condolences: 'Condoglianze',
      gallery: 'Galleria',
      biography: 'Biografia',
      funeralInfo: 'Informazioni Funerale',
      writeCondolence: 'Scrivi una condoglianza',
      yourName: 'Il tuo nome',
      yourMessage: 'Il tuo messaggio',
      sendCondolenceBtn: 'Invia Condoglianza',
      noCondolences: 'Nessuna condoglianza ancora',
      beFirst: 'Sii il primo a lasciare un messaggio'
    },
    // Candle
    candle: {
      title: 'Accendi una Candela',
      subtitle: 'Illumina il ricordo con una candela virtuale',
      selectType: 'Seleziona il tipo di candela',
      candle12h: 'Candela 12 Ore',
      candle24h: 'Candela 24 Ore',
      candle150h: 'Candela 150 Ore',
      candleForever: 'Candela Eterna',
      price: 'Prezzo',
      yourName: 'Il tuo nome',
      yourEmail: 'La tua email (opzionale)',
      dedication: 'Dedica (opzionale)',
      paymentMethod: 'Metodo di pagamento',
      bankTransfer: 'Bonifico Bancario',
      paypal: 'PayPal',
      revolut: 'Revolut',
      paymentInstructions: 'Istruzioni per il pagamento',
      confirmPayment: 'Conferma Richiesta',
      candleActivated: 'Candela attivata!',
      pendingApproval: 'In attesa di approvazione'
    },
    // Blog
    blog: {
      title: 'Blog',
      articles: 'Articoli',
      editArticle: 'Modifica Articolo',
      newArticle: 'Nuovo Articolo',
      articleTitle: 'Titolo Articolo',
      articleContent: 'Contenuto',
      publishDate: 'Data Pubblicazione',
      author: 'Autore',
      category: 'Categoria',
      tags: 'Tag',
      publish: 'Pubblica',
      draft: 'Bozza',
      myArticles: 'I Miei Articoli'
    }
  },
  en: {
    common: {
      home: 'Home',
      search: 'Search',
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      email: 'Email',
      password: 'Password',
      name: 'First Name',
      surname: 'Last Name',
      phone: 'Phone',
      send: 'Send',
      back: 'Back',
      next: 'Next',
      close: 'Close',
      or: 'or',
      readMore: 'Read more',
      viewAll: 'View all',
      learnMore: 'Learn more'
    },
    header: {
      searchObituaries: 'Search',
      funeralServices: 'Funeral Services',
      flowers: 'Flowers',
      resources: 'Resources / Guides',
      aboutUs: 'About Us',
      contact: 'Contact Us',
      reservedArea: 'Reserved Area',
      dashboard: 'Dashboard',
      welcome: 'Hello'
    },
    homepage: {
      heroTitle: 'Search for a loved one',
      heroSubtitle: 'Find obituaries and commemorate your loved ones by Name, Parish or City',
      searchPlaceholder: 'Name of deceased',
      cityPlaceholder: 'City or Parish',
      searchButton: 'Search',
      todayRemembrance: 'Today\'s Remembrances',
      todayRememberanceDesc: 'Join the community in remembrance',
      todayThoughts: 'shared thoughts',
      sendThought: 'Send a thought',
      recentObituaries: 'Recent Obituaries',
      viewAllObituaries: 'View all obituaries',
      partnerAgencies: 'Partner Agencies',
      becomePartner: 'Become a Partner',
      moreInfo: 'More Information',
      servicesTitle: 'Our Services',
      servicesDesc: 'We offer complete services to commemorate your loved ones'
    },
    aboutUs: {
      title: 'About Us',
      subtitle: 'Dedicated to memory and remembrance',
      mission: 'Our Mission',
      missionText: 'Resta in Pace was created with the goal of creating a digital place where the memory of our loved ones can be preserved and shared with dignity and respect.',
      vision: 'Our Vision',
      visionText: 'We believe every life deserves to be remembered. Our portal offers a safe and respectful space where families and friends can commemorate their loved ones.',
      values: 'Our Values',
      valueRespect: 'Respect',
      valueRespectDesc: 'We treat every memory with the utmost dignity',
      valueProfessionalism: 'Professionalism',
      valueProfessionalismDesc: 'High quality service for every family',
      valueDiscretion: 'Discretion',
      valueDiscretionDesc: 'Privacy and confidentiality always guaranteed',
      team: 'Our Team',
      teamDesc: 'A team dedicated to your service',
      contactUs: 'Contact Us',
      contactDesc: 'We are here to help you'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We are here to help you',
      formTitle: 'Send us a message',
      nameLabel: 'Your name',
      emailLabel: 'Your email',
      subjectLabel: 'Subject',
      messageLabel: 'Your message',
      sendButton: 'Send Message',
      successMessage: 'Message sent successfully!',
      address: 'Address',
      phoneLabel: 'Phone',
      emailContact: 'Email',
      workingHours: 'Working Hours',
      workingHoursValue: 'Mon - Fri: 9:00 AM - 6:00 PM'
    },
    services: {
      title: 'Funeral Services',
      subtitle: 'Complete services for farewell',
      obituaryService: 'Obituary Publication',
      obituaryServiceDesc: 'Publish obituaries online with photos, messages and dedications',
      flowersService: 'Send Flowers',
      flowersServiceDesc: 'Send floral arrangements to express closeness',
      candleService: 'Virtual Candles',
      candleServiceDesc: 'Light a virtual candle in memory',
      memorialService: 'Memorial Pages',
      memorialServiceDesc: 'Create pages dedicated to the memory of your loved ones',
      reminderService: 'Anniversary Reminders',
      reminderServiceDesc: 'Receive notifications for important anniversaries',
      donationService: 'Donations',
      donationServiceDesc: 'Make donations in memory of the deceased'
    },
    itineraries: {
      title: 'Memory Itineraries',
      subtitle: 'Discover places of remembrance in Italy',
      exploreMap: 'Explore the Map',
      featuredItineraries: 'Featured Itineraries',
      allItineraries: 'All Itineraries',
      readArticle: 'Read article',
      author: 'Author',
      publishedOn: 'Published on'
    },
    login: {
      privateLogin: 'Private Login',
      agencyLogin: 'Agency Login',
      bloggerLogin: 'Blogger Login',
      privateLoginDesc: 'Login to manage your memories and commemorations',
      agencyLoginDesc: 'Dedicated area for partner funeral agencies',
      bloggerLoginDesc: 'Dedicated area for bloggers to manage content',
      loginTitle: 'Welcome Back',
      registerTitle: 'Create Your Account',
      forgotPassword: 'Forgot Password?',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      rememberMe: 'Remember me',
      loginButton: 'Login',
      registerButton: 'Register',
      orContinueWith: 'or continue with',
      termsAgree: 'I agree to the Terms and Conditions',
      termsTitle: 'Terms and Conditions',
      agencyName: 'Agency Name',
      agencyCity: 'Agency City',
      confirmPassword: 'Confirm Password',
      passwordMismatch: 'Passwords do not match',
      invalidEmail: 'Invalid email',
      weakPassword: 'Password must be at least 6 characters',
      loginError: 'Invalid email or password',
      registerSuccess: 'Registration completed successfully',
      selectUserType: 'Account type'
    },
    passwordReset: {
      title: 'Reset Password',
      subtitle: 'Enter your email to receive the reset link',
      sendLink: 'Send Reset Link',
      linkSent: 'Link sent! Check your email',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      resetPassword: 'Reset Password',
      passwordChanged: 'Password changed successfully',
      backToLogin: 'Back to login',
      invalidToken: 'Invalid or expired link',
      tokenExpired: 'The link has expired. Request a new one.'
    },
    footer: {
      description: 'The Italian portal dedicated to memory, obituaries and the culture of farewell. Professionalism and discretion at your service.',
      services: 'Services',
      resources: 'Resources',
      contacts: 'Contacts',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      termsConditions: 'Terms and Conditions',
      allRightsReserved: 'All rights reserved',
      searchObituary: 'Search Obituary',
      flowersAndThoughts: 'Flowers and Thoughts',
      funeralOrganization: 'Funeral Organization',
      cemeteryServices: 'Cemetery Services',
      blogAndSupport: 'Blog & Support',
      faq: 'FAQ',
      practicalGuide: 'Practical Guide',
      workWithUs: 'Work with Us',
      administration: 'Administration'
    },
    obituary: {
      search: 'Search Obituaries',
      searchPlaceholder: 'Name of deceased',
      cityPlaceholder: 'City or Parish',
      found: 'Found',
      obituaries: 'obituaries',
      viewObituary: 'View obituary',
      sendFlowers: 'Send Flowers',
      sendCondolence: 'Condolence',
      share: 'Share',
      remindMe: 'Remind Me',
      lightCandle: 'Light a Candle',
      donate: 'Donate to family',
      condolences: 'Condolences',
      gallery: 'Gallery',
      biography: 'Biography',
      funeralInfo: 'Funeral Information',
      writeCondolence: 'Write a condolence',
      yourName: 'Your name',
      yourMessage: 'Your message',
      sendCondolenceBtn: 'Send Condolence',
      noCondolences: 'No condolences yet',
      beFirst: 'Be the first to leave a message'
    },
    candle: {
      title: 'Light a Candle',
      subtitle: 'Illuminate the memory with a virtual candle',
      selectType: 'Select candle type',
      candle12h: '12 Hour Candle',
      candle24h: '24 Hour Candle',
      candle150h: '150 Hour Candle',
      candleForever: 'Eternal Candle',
      price: 'Price',
      yourName: 'Your name',
      yourEmail: 'Your email (optional)',
      dedication: 'Dedication (optional)',
      paymentMethod: 'Payment method',
      bankTransfer: 'Bank Transfer',
      paypal: 'PayPal',
      revolut: 'Revolut',
      paymentInstructions: 'Payment instructions',
      confirmPayment: 'Confirm Request',
      candleActivated: 'Candle activated!',
      pendingApproval: 'Pending approval'
    },
    blog: {
      title: 'Blog',
      articles: 'Articles',
      editArticle: 'Edit Article',
      newArticle: 'New Article',
      articleTitle: 'Article Title',
      articleContent: 'Content',
      publishDate: 'Publication Date',
      author: 'Author',
      category: 'Category',
      tags: 'Tags',
      publish: 'Publish',
      draft: 'Draft',
      myArticles: 'My Articles'
    }
  },
  fr: {
    common: {
      home: 'Accueil',
      search: 'Rechercher',
      login: 'Connexion',
      logout: 'Déconnexion',
      register: "S'inscrire",
      save: 'Enregistrer',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      email: 'Email',
      password: 'Mot de passe',
      name: 'Prénom',
      surname: 'Nom',
      phone: 'Téléphone',
      send: 'Envoyer',
      back: 'Retour',
      next: 'Suivant',
      close: 'Fermer',
      or: 'ou',
      readMore: 'Lire la suite',
      viewAll: 'Voir tout',
      learnMore: 'En savoir plus'
    },
    header: {
      searchObituaries: 'Rechercher',
      funeralServices: 'Services Funéraires',
      flowers: 'Fleurs',
      resources: 'Ressources / Guides',
      aboutUs: 'À propos',
      contact: 'Contactez-nous',
      reservedArea: 'Espace Réservé',
      dashboard: 'Tableau de bord',
      welcome: 'Bonjour'
    },
    homepage: {
      heroTitle: 'Rechercher un être cher',
      heroSubtitle: 'Trouvez des nécrologies et commémorez vos proches par Nom, Paroisse ou Ville',
      searchPlaceholder: 'Nom du défunt',
      cityPlaceholder: 'Ville ou Paroisse',
      searchButton: 'Rechercher',
      todayRemembrance: 'Commémorations du Jour',
      todayRememberanceDesc: 'Rejoignez la communauté dans le souvenir',
      todayThoughts: 'pensées partagées',
      sendThought: 'Envoyer une pensée',
      recentObituaries: 'Nécrologies Récentes',
      viewAllObituaries: 'Voir toutes les nécrologies',
      partnerAgencies: 'Agences Partenaires',
      becomePartner: 'Devenir Partenaire',
      moreInfo: 'Plus d\'Informations',
      servicesTitle: 'Nos Services',
      servicesDesc: 'Nous offrons des services complets pour commémorer vos proches'
    },
    aboutUs: {
      title: 'À Propos de Nous',
      subtitle: 'Dédiés à la mémoire et au souvenir',
      mission: 'Notre Mission',
      missionText: 'Resta in Pace a été créé dans le but de créer un lieu numérique où la mémoire de nos proches peut être préservée et partagée avec dignité et respect.',
      vision: 'Notre Vision',
      visionText: 'Nous croyons que chaque vie mérite d\'être rappelée. Notre portail offre un espace sûr et respectueux où les familles et amis peuvent commémorer leurs proches.',
      values: 'Nos Valeurs',
      valueRespect: 'Respect',
      valueRespectDesc: 'Nous traitons chaque mémoire avec la plus grande dignité',
      valueProfessionalism: 'Professionnalisme',
      valueProfessionalismDesc: 'Service de haute qualité pour chaque famille',
      valueDiscretion: 'Discrétion',
      valueDiscretionDesc: 'Confidentialité et vie privée toujours garanties',
      team: 'Notre Équipe',
      teamDesc: 'Une équipe dédiée à votre service',
      contactUs: 'Contactez-nous',
      contactDesc: 'Nous sommes là pour vous aider'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes là pour vous aider',
      formTitle: 'Envoyez-nous un message',
      nameLabel: 'Votre nom',
      emailLabel: 'Votre email',
      subjectLabel: 'Objet',
      messageLabel: 'Votre message',
      sendButton: 'Envoyer le Message',
      successMessage: 'Message envoyé avec succès!',
      address: 'Adresse',
      phoneLabel: 'Téléphone',
      emailContact: 'Email',
      workingHours: 'Heures d\'ouverture',
      workingHoursValue: 'Lun - Ven: 9h00 - 18h00'
    },
    services: {
      title: 'Services Funéraires',
      subtitle: 'Services complets pour l\'adieu',
      obituaryService: 'Publication de Nécrologies',
      obituaryServiceDesc: 'Publiez des nécrologies en ligne avec photos, messages et dédicaces',
      flowersService: 'Envoi de Fleurs',
      flowersServiceDesc: 'Envoyez des compositions florales pour exprimer votre proximité',
      candleService: 'Bougies Virtuelles',
      candleServiceDesc: 'Allumez une bougie virtuelle en mémoire',
      memorialService: 'Pages Commémoratives',
      memorialServiceDesc: 'Créez des pages dédiées à la mémoire de vos proches',
      reminderService: 'Rappels d\'Anniversaire',
      reminderServiceDesc: 'Recevez des notifications pour les anniversaires importants',
      donationService: 'Dons',
      donationServiceDesc: 'Faites des dons en mémoire du défunt'
    },
    itineraries: {
      title: 'Itinéraires de la Mémoire',
      subtitle: 'Découvrez les lieux du souvenir en Italie',
      exploreMap: 'Explorer la Carte',
      featuredItineraries: 'Itinéraires en Vedette',
      allItineraries: 'Tous les Itinéraires',
      readArticle: 'Lire l\'article',
      author: 'Auteur',
      publishedOn: 'Publié le'
    },
    login: {
      privateLogin: 'Connexion Privée',
      agencyLogin: 'Connexion Agence',
      bloggerLogin: 'Connexion Blogger',
      privateLoginDesc: 'Connectez-vous pour gérer vos souvenirs',
      agencyLoginDesc: 'Espace dédié aux agences funéraires partenaires',
      bloggerLoginDesc: 'Espace dédié aux blogueurs pour gérer le contenu',
      loginTitle: 'Bienvenue',
      registerTitle: 'Créez votre compte',
      forgotPassword: 'Mot de passe oublié?',
      noAccount: "Pas de compte?",
      hasAccount: 'Déjà un compte?',
      rememberMe: 'Se souvenir de moi',
      loginButton: 'Connexion',
      registerButton: "S'inscrire",
      orContinueWith: 'ou continuer avec',
      termsAgree: "J'accepte les Conditions Générales",
      termsTitle: 'Conditions Générales',
      agencyName: "Nom de l'Agence",
      agencyCity: "Ville de l'Agence",
      confirmPassword: 'Confirmer le mot de passe',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      invalidEmail: 'Email invalide',
      weakPassword: 'Le mot de passe doit contenir au moins 6 caractères',
      loginError: 'Email ou mot de passe incorrect',
      registerSuccess: 'Inscription réussie',
      selectUserType: 'Type de compte'
    },
    passwordReset: {
      title: 'Récupérer le mot de passe',
      subtitle: 'Entrez votre email pour recevoir le lien de réinitialisation',
      sendLink: 'Envoyer le lien',
      linkSent: 'Lien envoyé! Vérifiez votre email',
      newPassword: 'Nouveau mot de passe',
      confirmNewPassword: 'Confirmer le nouveau mot de passe',
      resetPassword: 'Réinitialiser le mot de passe',
      passwordChanged: 'Mot de passe modifié avec succès',
      backToLogin: 'Retour à la connexion',
      invalidToken: 'Lien invalide ou expiré',
      tokenExpired: 'Le lien a expiré. Demandez-en un nouveau.'
    },
    footer: {
      description: 'Le portail italien dédié à la mémoire, aux nécrologies et à la culture de l\'adieu.',
      services: 'Services',
      resources: 'Ressources',
      contacts: 'Contacts',
      privacyPolicy: 'Politique de Confidentialité',
      cookiePolicy: 'Politique des Cookies',
      termsConditions: 'Conditions Générales',
      allRightsReserved: 'Tous droits réservés',
      searchObituary: 'Rechercher Nécrologie',
      flowersAndThoughts: 'Fleurs et Pensées',
      funeralOrganization: 'Organisation Funéraire',
      cemeteryServices: 'Services Cimetière',
      blogAndSupport: 'Blog & Support',
      faq: 'FAQ',
      practicalGuide: 'Guide Pratique',
      workWithUs: 'Travailler avec Nous',
      administration: 'Administration'
    },
    obituary: {
      search: 'Rechercher Nécrologies',
      searchPlaceholder: 'Nom du défunt',
      cityPlaceholder: 'Ville ou Paroisse',
      found: 'Trouvé',
      obituaries: 'nécrologies',
      viewObituary: 'Voir la nécrologie',
      sendFlowers: 'Envoyer des Fleurs',
      sendCondolence: 'Condoléance',
      share: 'Partager',
      remindMe: 'Me rappeler',
      lightCandle: 'Allumer une Bougie',
      donate: 'Faire un don à la famille',
      condolences: 'Condoléances',
      gallery: 'Galerie',
      biography: 'Biographie',
      funeralInfo: 'Informations Funéraires',
      writeCondolence: 'Écrire une condoléance',
      yourName: 'Votre nom',
      yourMessage: 'Votre message',
      sendCondolenceBtn: 'Envoyer Condoléance',
      noCondolences: 'Pas encore de condoléances',
      beFirst: 'Soyez le premier à laisser un message'
    },
    candle: {
      title: 'Allumer une Bougie',
      subtitle: 'Illuminez le souvenir avec une bougie virtuelle',
      selectType: 'Sélectionner le type de bougie',
      candle12h: 'Bougie 12 Heures',
      candle24h: 'Bougie 24 Heures',
      candle150h: 'Bougie 150 Heures',
      candleForever: 'Bougie Éternelle',
      price: 'Prix',
      yourName: 'Votre nom',
      yourEmail: 'Votre email (optionnel)',
      dedication: 'Dédicace (optionnel)',
      paymentMethod: 'Méthode de paiement',
      bankTransfer: 'Virement Bancaire',
      paypal: 'PayPal',
      revolut: 'Revolut',
      paymentInstructions: 'Instructions de paiement',
      confirmPayment: 'Confirmer la Demande',
      candleActivated: 'Bougie activée!',
      pendingApproval: 'En attente d\'approbation'
    },
    blog: {
      title: 'Blog',
      articles: 'Articles',
      editArticle: "Modifier l'article",
      newArticle: 'Nouvel Article',
      articleTitle: "Titre de l'article",
      articleContent: 'Contenu',
      publishDate: 'Date de Publication',
      author: 'Auteur',
      category: 'Catégorie',
      tags: 'Mots-clés',
      publish: 'Publier',
      draft: 'Brouillon',
      myArticles: 'Mes Articles'
    }
  },
  de: {
    common: {
      home: 'Startseite',
      search: 'Suchen',
      login: 'Anmelden',
      logout: 'Abmelden',
      register: 'Registrieren',
      save: 'Speichern',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      loading: 'Laden...',
      error: 'Fehler',
      success: 'Erfolg',
      email: 'E-Mail',
      password: 'Passwort',
      name: 'Vorname',
      surname: 'Nachname',
      phone: 'Telefon',
      send: 'Senden',
      back: 'Zurück',
      next: 'Weiter',
      close: 'Schließen',
      or: 'oder',
      readMore: 'Mehr lesen',
      viewAll: 'Alle anzeigen',
      learnMore: 'Mehr erfahren'
    },
    header: {
      searchObituaries: 'Suchen',
      funeralServices: 'Bestattungsdienste',
      flowers: 'Blumen',
      resources: 'Ressourcen / Anleitungen',
      aboutUs: 'Über uns',
      contact: 'Kontakt',
      reservedArea: 'Reservierter Bereich',
      dashboard: 'Dashboard',
      welcome: 'Hallo'
    },
    homepage: {
      heroTitle: 'Suchen Sie einen geliebten Menschen',
      heroSubtitle: 'Finden Sie Nachrufe und gedenken Sie Ihrer Lieben nach Name, Gemeinde oder Stadt',
      searchPlaceholder: 'Name des Verstorbenen',
      cityPlaceholder: 'Stadt oder Gemeinde',
      searchButton: 'Suchen',
      todayRemembrance: 'Heutige Gedenkfeiern',
      todayRememberanceDesc: 'Schließen Sie sich der Gemeinschaft im Gedenken an',
      todayThoughts: 'geteilte Gedanken',
      sendThought: 'Einen Gedanken senden',
      recentObituaries: 'Aktuelle Nachrufe',
      viewAllObituaries: 'Alle Nachrufe anzeigen',
      partnerAgencies: 'Partneragenturen',
      becomePartner: 'Partner werden',
      moreInfo: 'Mehr Informationen',
      servicesTitle: 'Unsere Dienste',
      servicesDesc: 'Wir bieten umfassende Dienste zum Gedenken an Ihre Lieben'
    },
    aboutUs: {
      title: 'Über Uns',
      subtitle: 'Der Erinnerung und dem Gedenken gewidmet',
      mission: 'Unsere Mission',
      missionText: 'Resta in Pace wurde mit dem Ziel gegründet, einen digitalen Ort zu schaffen, an dem die Erinnerung an unsere Lieben mit Würde und Respekt bewahrt und geteilt werden kann.',
      vision: 'Unsere Vision',
      visionText: 'Wir glauben, dass jedes Leben es verdient, erinnert zu werden. Unser Portal bietet einen sicheren und respektvollen Raum, in dem Familien und Freunde ihrer Lieben gedenken können.',
      values: 'Unsere Werte',
      valueRespect: 'Respekt',
      valueRespectDesc: 'Wir behandeln jede Erinnerung mit höchster Würde',
      valueProfessionalism: 'Professionalität',
      valueProfessionalismDesc: 'Hochwertige Dienstleistung für jede Familie',
      valueDiscretion: 'Diskretion',
      valueDiscretionDesc: 'Privatsphäre und Vertraulichkeit immer garantiert',
      team: 'Unser Team',
      teamDesc: 'Ein Team, das Ihnen gewidmet ist',
      contactUs: 'Kontaktieren Sie uns',
      contactDesc: 'Wir sind hier, um Ihnen zu helfen'
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir sind hier, um Ihnen zu helfen',
      formTitle: 'Senden Sie uns eine Nachricht',
      nameLabel: 'Ihr Name',
      emailLabel: 'Ihre E-Mail',
      subjectLabel: 'Betreff',
      messageLabel: 'Ihre Nachricht',
      sendButton: 'Nachricht senden',
      successMessage: 'Nachricht erfolgreich gesendet!',
      address: 'Adresse',
      phoneLabel: 'Telefon',
      emailContact: 'E-Mail',
      workingHours: 'Öffnungszeiten',
      workingHoursValue: 'Mo - Fr: 9:00 - 18:00 Uhr'
    },
    services: {
      title: 'Bestattungsdienste',
      subtitle: 'Umfassende Dienste für den Abschied',
      obituaryService: 'Nachruf-Veröffentlichung',
      obituaryServiceDesc: 'Veröffentlichen Sie Nachrufe online mit Fotos, Nachrichten und Widmungen',
      flowersService: 'Blumen senden',
      flowersServiceDesc: 'Senden Sie Blumenarrangements, um Nähe auszudrücken',
      candleService: 'Virtuelle Kerzen',
      candleServiceDesc: 'Zünden Sie eine virtuelle Kerze zur Erinnerung an',
      memorialService: 'Gedenkseiten',
      memorialServiceDesc: 'Erstellen Sie Seiten zum Gedenken an Ihre Lieben',
      reminderService: 'Jahrestag-Erinnerungen',
      reminderServiceDesc: 'Erhalten Sie Benachrichtigungen für wichtige Jahrestage',
      donationService: 'Spenden',
      donationServiceDesc: 'Spenden Sie zum Gedenken an den Verstorbenen'
    },
    itineraries: {
      title: 'Erinnerungs-Routen',
      subtitle: 'Entdecken Sie Orte der Erinnerung in Italien',
      exploreMap: 'Karte erkunden',
      featuredItineraries: 'Ausgewählte Routen',
      allItineraries: 'Alle Routen',
      readArticle: 'Artikel lesen',
      author: 'Autor',
      publishedOn: 'Veröffentlicht am'
    },
    login: {
      privateLogin: 'Private Anmeldung',
      agencyLogin: 'Agentur Anmeldung',
      bloggerLogin: 'Blogger Anmeldung',
      privateLoginDesc: 'Melden Sie sich an, um Ihre Erinnerungen zu verwalten',
      agencyLoginDesc: 'Bereich für Partner-Bestattungsunternehmen',
      bloggerLoginDesc: 'Bereich für Blogger zur Inhaltsverwaltung',
      loginTitle: 'Willkommen zurück',
      registerTitle: 'Konto erstellen',
      forgotPassword: 'Passwort vergessen?',
      noAccount: 'Noch kein Konto?',
      hasAccount: 'Bereits ein Konto?',
      rememberMe: 'Angemeldet bleiben',
      loginButton: 'Anmelden',
      registerButton: 'Registrieren',
      orContinueWith: 'oder weiter mit',
      termsAgree: 'Ich akzeptiere die AGB',
      termsTitle: 'Allgemeine Geschäftsbedingungen',
      agencyName: 'Agenturname',
      agencyCity: 'Agenturstadt',
      confirmPassword: 'Passwort bestätigen',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      invalidEmail: 'Ungültige E-Mail',
      weakPassword: 'Passwort muss mindestens 6 Zeichen haben',
      loginError: 'Ungültige E-Mail oder Passwort',
      registerSuccess: 'Registrierung erfolgreich',
      selectUserType: 'Kontotyp'
    },
    passwordReset: {
      title: 'Passwort zurücksetzen',
      subtitle: 'Geben Sie Ihre E-Mail ein, um den Reset-Link zu erhalten',
      sendLink: 'Reset-Link senden',
      linkSent: 'Link gesendet! Prüfen Sie Ihre E-Mail',
      newPassword: 'Neues Passwort',
      confirmNewPassword: 'Neues Passwort bestätigen',
      resetPassword: 'Passwort zurücksetzen',
      passwordChanged: 'Passwort erfolgreich geändert',
      backToLogin: 'Zurück zur Anmeldung',
      invalidToken: 'Ungültiger oder abgelaufener Link',
      tokenExpired: 'Der Link ist abgelaufen. Fordern Sie einen neuen an.'
    },
    footer: {
      description: 'Das italienische Portal für Erinnerung, Nachrufe und Abschiedskultur.',
      services: 'Dienste',
      resources: 'Ressourcen',
      contacts: 'Kontakte',
      privacyPolicy: 'Datenschutzrichtlinie',
      cookiePolicy: 'Cookie-Richtlinie',
      termsConditions: 'AGB',
      allRightsReserved: 'Alle Rechte vorbehalten',
      searchObituary: 'Nachruf suchen',
      flowersAndThoughts: 'Blumen und Gedanken',
      funeralOrganization: 'Bestattungsorganisation',
      cemeteryServices: 'Friedhofsdienste',
      blogAndSupport: 'Blog & Support',
      faq: 'FAQ',
      practicalGuide: 'Praktischer Leitfaden',
      workWithUs: 'Mit uns arbeiten',
      administration: 'Administration'
    },
    obituary: {
      search: 'Nachrufe suchen',
      searchPlaceholder: 'Name des Verstorbenen',
      cityPlaceholder: 'Stadt oder Gemeinde',
      found: 'Gefunden',
      obituaries: 'Nachrufe',
      viewObituary: 'Nachruf ansehen',
      sendFlowers: 'Blumen senden',
      sendCondolence: 'Beileid',
      share: 'Teilen',
      remindMe: 'Erinnere mich',
      lightCandle: 'Kerze anzünden',
      donate: 'An Familie spenden',
      condolences: 'Beileidsbekundungen',
      gallery: 'Galerie',
      biography: 'Biografie',
      funeralInfo: 'Bestattungsinformationen',
      writeCondolence: 'Beileid schreiben',
      yourName: 'Ihr Name',
      yourMessage: 'Ihre Nachricht',
      sendCondolenceBtn: 'Beileid senden',
      noCondolences: 'Noch keine Beileidsbekundungen',
      beFirst: 'Seien Sie der Erste, der eine Nachricht hinterlässt'
    },
    candle: {
      title: 'Kerze anzünden',
      subtitle: 'Erleuchten Sie die Erinnerung mit einer virtuellen Kerze',
      selectType: 'Kerzentyp auswählen',
      candle12h: '12-Stunden-Kerze',
      candle24h: '24-Stunden-Kerze',
      candle150h: '150-Stunden-Kerze',
      candleForever: 'Ewige Kerze',
      price: 'Preis',
      yourName: 'Ihr Name',
      yourEmail: 'Ihre E-Mail (optional)',
      dedication: 'Widmung (optional)',
      paymentMethod: 'Zahlungsmethode',
      bankTransfer: 'Banküberweisung',
      paypal: 'PayPal',
      revolut: 'Revolut',
      paymentInstructions: 'Zahlungsanweisungen',
      confirmPayment: 'Anfrage bestätigen',
      candleActivated: 'Kerze aktiviert!',
      pendingApproval: 'Genehmigung ausstehend'
    },
    blog: {
      title: 'Blog',
      articles: 'Artikel',
      editArticle: 'Artikel bearbeiten',
      newArticle: 'Neuer Artikel',
      articleTitle: 'Artikeltitel',
      articleContent: 'Inhalt',
      publishDate: 'Veröffentlichungsdatum',
      author: 'Autor',
      category: 'Kategorie',
      tags: 'Tags',
      publish: 'Veröffentlichen',
      draft: 'Entwurf',
      myArticles: 'Meine Artikel'
    }
  },
  es: {
    common: {
      home: 'Inicio',
      search: 'Buscar',
      login: 'Acceder',
      logout: 'Cerrar sesión',
      register: 'Registrarse',
      save: 'Guardar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      email: 'Correo electrónico',
      password: 'Contraseña',
      name: 'Nombre',
      surname: 'Apellido',
      phone: 'Teléfono',
      send: 'Enviar',
      back: 'Atrás',
      next: 'Siguiente',
      close: 'Cerrar',
      or: 'o',
      readMore: 'Leer más',
      viewAll: 'Ver todo',
      learnMore: 'Saber más'
    },
    header: {
      searchObituaries: 'Buscar',
      funeralServices: 'Servicios Funerarios',
      flowers: 'Flores',
      resources: 'Recursos / Guías',
      aboutUs: 'Sobre Nosotros',
      contact: 'Contáctenos',
      reservedArea: 'Área Reservada',
      dashboard: 'Panel',
      welcome: 'Hola'
    },
    homepage: {
      heroTitle: 'Busca a un ser querido',
      heroSubtitle: 'Encuentra obituarios y conmemora a tus seres queridos por Nombre, Parroquia o Ciudad',
      searchPlaceholder: 'Nombre del fallecido',
      cityPlaceholder: 'Ciudad o Parroquia',
      searchButton: 'Buscar',
      todayRemembrance: 'Conmemoraciones de Hoy',
      todayRememberanceDesc: 'Únete a la comunidad en el recuerdo',
      todayThoughts: 'pensamientos compartidos',
      sendThought: 'Enviar un pensamiento',
      recentObituaries: 'Obituarios Recientes',
      viewAllObituaries: 'Ver todos los obituarios',
      partnerAgencies: 'Agencias Asociadas',
      becomePartner: 'Conviértete en Socio',
      moreInfo: 'Más Información',
      servicesTitle: 'Nuestros Servicios',
      servicesDesc: 'Ofrecemos servicios completos para conmemorar a tus seres queridos'
    },
    aboutUs: {
      title: 'Sobre Nosotros',
      subtitle: 'Dedicados a la memoria y el recuerdo',
      mission: 'Nuestra Misión',
      missionText: 'Resta in Pace fue creado con el objetivo de crear un lugar digital donde la memoria de nuestros seres queridos pueda ser preservada y compartida con dignidad y respeto.',
      vision: 'Nuestra Visión',
      visionText: 'Creemos que cada vida merece ser recordada. Nuestro portal ofrece un espacio seguro y respetuoso donde familias y amigos pueden conmemorar a sus seres queridos.',
      values: 'Nuestros Valores',
      valueRespect: 'Respeto',
      valueRespectDesc: 'Tratamos cada memoria con la máxima dignidad',
      valueProfessionalism: 'Profesionalismo',
      valueProfessionalismDesc: 'Servicio de alta calidad para cada familia',
      valueDiscretion: 'Discreción',
      valueDiscretionDesc: 'Privacidad y confidencialidad siempre garantizadas',
      team: 'Nuestro Equipo',
      teamDesc: 'Un equipo dedicado a tu servicio',
      contactUs: 'Contáctenos',
      contactDesc: 'Estamos aquí para ayudarte'
    },
    contact: {
      title: 'Contáctenos',
      subtitle: 'Estamos aquí para ayudarte',
      formTitle: 'Envíanos un mensaje',
      nameLabel: 'Tu nombre',
      emailLabel: 'Tu correo electrónico',
      subjectLabel: 'Asunto',
      messageLabel: 'Tu mensaje',
      sendButton: 'Enviar Mensaje',
      successMessage: '¡Mensaje enviado con éxito!',
      address: 'Dirección',
      phoneLabel: 'Teléfono',
      emailContact: 'Correo electrónico',
      workingHours: 'Horario de atención',
      workingHoursValue: 'Lun - Vie: 9:00 - 18:00'
    },
    services: {
      title: 'Servicios Funerarios',
      subtitle: 'Servicios completos para la despedida',
      obituaryService: 'Publicación de Obituarios',
      obituaryServiceDesc: 'Publica obituarios en línea con fotos, mensajes y dedicatorias',
      flowersService: 'Envío de Flores',
      flowersServiceDesc: 'Envía arreglos florales para expresar cercanía',
      candleService: 'Velas Virtuales',
      candleServiceDesc: 'Enciende una vela virtual en memoria',
      memorialService: 'Páginas Conmemorativas',
      memorialServiceDesc: 'Crea páginas dedicadas a la memoria de tus seres queridos',
      reminderService: 'Recordatorios de Aniversario',
      reminderServiceDesc: 'Recibe notificaciones para aniversarios importantes',
      donationService: 'Donaciones',
      donationServiceDesc: 'Haz donaciones en memoria del fallecido'
    },
    itineraries: {
      title: 'Itinerarios de la Memoria',
      subtitle: 'Descubre lugares de recuerdo en Italia',
      exploreMap: 'Explorar el Mapa',
      featuredItineraries: 'Itinerarios Destacados',
      allItineraries: 'Todos los Itinerarios',
      readArticle: 'Leer artículo',
      author: 'Autor',
      publishedOn: 'Publicado el'
    },
    login: {
      privateLogin: 'Acceso Privado',
      agencyLogin: 'Acceso Agencia',
      bloggerLogin: 'Acceso Blogger',
      privateLoginDesc: 'Accede para gestionar tus recuerdos y conmemoraciones',
      agencyLoginDesc: 'Área dedicada a agencias funerarias asociadas',
      bloggerLoginDesc: 'Área dedicada a bloggers para gestionar contenido',
      loginTitle: 'Bienvenido de nuevo',
      registerTitle: 'Crea tu cuenta',
      forgotPassword: '¿Olvidaste tu contraseña?',
      noAccount: '¿No tienes cuenta?',
      hasAccount: '¿Ya tienes cuenta?',
      rememberMe: 'Recuérdame',
      loginButton: 'Acceder',
      registerButton: 'Registrarse',
      orContinueWith: 'o continuar con',
      termsAgree: 'Acepto los Términos y Condiciones',
      termsTitle: 'Términos y Condiciones',
      agencyName: 'Nombre de Agencia',
      agencyCity: 'Ciudad de Agencia',
      confirmPassword: 'Confirmar Contraseña',
      passwordMismatch: 'Las contraseñas no coinciden',
      invalidEmail: 'Correo electrónico no válido',
      weakPassword: 'La contraseña debe tener al menos 6 caracteres',
      loginError: 'Correo o contraseña incorrectos',
      registerSuccess: 'Registro completado con éxito',
      selectUserType: 'Tipo de cuenta'
    },
    passwordReset: {
      title: 'Recuperar Contraseña',
      subtitle: 'Ingresa tu correo para recibir el enlace de recuperación',
      sendLink: 'Enviar Enlace',
      linkSent: '¡Enlace enviado! Revisa tu correo',
      newPassword: 'Nueva Contraseña',
      confirmNewPassword: 'Confirmar Nueva Contraseña',
      resetPassword: 'Restablecer Contraseña',
      passwordChanged: 'Contraseña cambiada con éxito',
      backToLogin: 'Volver al inicio de sesión',
      invalidToken: 'Enlace no válido o expirado',
      tokenExpired: 'El enlace ha expirado. Solicita uno nuevo.'
    },
    footer: {
      description: 'El portal italiano dedicado a la memoria, obituarios y la cultura de la despedida.',
      services: 'Servicios',
      resources: 'Recursos',
      contacts: 'Contactos',
      privacyPolicy: 'Política de Privacidad',
      cookiePolicy: 'Política de Cookies',
      termsConditions: 'Términos y Condiciones',
      allRightsReserved: 'Todos los derechos reservados',
      searchObituary: 'Buscar Obituario',
      flowersAndThoughts: 'Flores y Pensamientos',
      funeralOrganization: 'Organización Funeraria',
      cemeteryServices: 'Servicios de Cementerio',
      blogAndSupport: 'Blog y Soporte',
      faq: 'Preguntas Frecuentes',
      practicalGuide: 'Guía Práctica',
      workWithUs: 'Trabaja con Nosotros',
      administration: 'Administración'
    },
    obituary: {
      search: 'Buscar Obituarios',
      searchPlaceholder: 'Nombre del fallecido',
      cityPlaceholder: 'Ciudad o Parroquia',
      found: 'Encontrados',
      obituaries: 'obituarios',
      viewObituary: 'Ver obituario',
      sendFlowers: 'Enviar Flores',
      sendCondolence: 'Condolencia',
      share: 'Compartir',
      remindMe: 'Recordarme',
      lightCandle: 'Encender una Vela',
      donate: 'Donar a la familia',
      condolences: 'Condolencias',
      gallery: 'Galería',
      biography: 'Biografía',
      funeralInfo: 'Información del Funeral',
      writeCondolence: 'Escribir una condolencia',
      yourName: 'Tu nombre',
      yourMessage: 'Tu mensaje',
      sendCondolenceBtn: 'Enviar Condolencia',
      noCondolences: 'Aún no hay condolencias',
      beFirst: 'Sé el primero en dejar un mensaje'
    },
    candle: {
      title: 'Encender una Vela',
      subtitle: 'Ilumina el recuerdo con una vela virtual',
      selectType: 'Seleccionar tipo de vela',
      candle12h: 'Vela de 12 Horas',
      candle24h: 'Vela de 24 Horas',
      candle150h: 'Vela de 150 Horas',
      candleForever: 'Vela Eterna',
      price: 'Precio',
      yourName: 'Tu nombre',
      yourEmail: 'Tu correo (opcional)',
      dedication: 'Dedicatoria (opcional)',
      paymentMethod: 'Método de pago',
      bankTransfer: 'Transferencia Bancaria',
      paypal: 'PayPal',
      revolut: 'Revolut',
      paymentInstructions: 'Instrucciones de pago',
      confirmPayment: 'Confirmar Solicitud',
      candleActivated: '¡Vela activada!',
      pendingApproval: 'Pendiente de aprobación'
    },
    blog: {
      title: 'Blog',
      articles: 'Artículos',
      editArticle: 'Editar Artículo',
      newArticle: 'Nuevo Artículo',
      articleTitle: 'Título del Artículo',
      articleContent: 'Contenido',
      publishDate: 'Fecha de Publicación',
      author: 'Autor',
      category: 'Categoría',
      tags: 'Etiquetas',
      publish: 'Publicar',
      draft: 'Borrador',
      myArticles: 'Mis Artículos'
    }
  }
};

// Language names for selector
const languageNames = {
  it: { name: 'Italiano', flag: '🇮🇹' },
  en: { name: 'English', flag: '🇬🇧' },
  fr: { name: 'Français', flag: '🇫🇷' },
  de: { name: 'Deutsch', flag: '🇩🇪' },
  es: { name: 'Español', flag: '🇪🇸' }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get from localStorage or default to Italian
    const saved = localStorage.getItem('language');
    return saved && translations[saved] ? saved : 'it';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
   
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback to Italian
        value = translations['it'];
        for (const k2 of keys) {
          if (value && value[k2]) {
            value = value[k2];
          } else {
            return key; // Return key if not found
          }
        }
        break;
      }
    }
    
    return value;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      changeLanguage, 
      t, 
      languages: Object.keys(translations),
      languageNames
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
